import { localStorage } from '../../../helper/storage';

const storeKeys = {
	nameAndType: 'showNameAndAlertTooltip',
	metric: 'showMetricTooltip',
	addStore: 'showAddStoreTooltip',
	searchStore: 'showSearchStoreTooltip',
	addItem: 'showAddItemTooltip',
	searchItem: 'showSearchItemTooltip',
	previewAlert: 'showPreviewAlertTooltip',
	allSet: 'showAllSetTooltip',
};

export const updateFTUXStoreValues = (enable = true) => {
	const keys = Object.values(storeKeys);
	try {
		const data = {};
		keys.forEach((key) => (data[key] = enable));
		// Sets all tooltip flags to true in LocalStorage
		localStorage.setItem('customAlertTooltip', data);
	} catch (error) {
		//
	}
};

/**
 * This will update local storage tooltip flag to false
 * when the user click on Got it button of each tooltip.
 * key='nameAndType' or ...
 */
export const storeTooltipData = (key) => {
	try {
		const storedValue = localStorage.getItem('customAlertTooltip');
		const data = { ...storedValue };
		if (storeKeys[key]) {
			// Update the particular tooltip flag to false
			data[storeKeys[key]] = false;
			localStorage.setItem('customAlertTooltip', data);
		}
	} catch (error) {
		//
	}
};

export const getStoredTooltipData = () =>
	localStorage.getItem('customAlertTooltip');
